export function getSearchQuery(q?: string) {
  if (!q) {
    return ""
  }

  const trimmed = q.trim()

  // There is a minimum length for the Supabase full text search
  if (trimmed.length < 3) {
    return ""
  }

  // We're using the websearch type, which allows for spaces
  return trimmed.split(/\s+/).join("+")
}
